<div class="wrapper" [ngClass]="{ 'manual-size': isPreviewMode() }">
  <main>
    <section class="">
      <div class="app-comp">
        <div class="app-comp__left">
          <div class="app-comp__info-wrapper">
            <div class="app-comp__logo">
              <!--              @if (config().designTemplateId) {-->
              <!--                <img alt="App icon" [src]="previewDesignLogo" />-->
              <!--              } @else {-->
              <img alt="App icon" [src]="config().logo?.image" />
              <!--              }-->
            </div>
            <div class="app-comp__main-info">
              <div class="app-comp__info">
                <div class="app-comp__info-left">
                  <div class="app-comp__info-title">{{ previewContent.name }}
                    @if (config().verificationCheckmark) {
                      <img src="/assets/lib-assets/classic-template/images/choise.png" />
                    }
                  </div>
                  <div class="app-comp__info-subtitle">
                    <span>{{ previewContent.category }}</span>
                  </div>
                  <div class="app-comp__info-content">
                    <div class="app-comp__age-rate">
                      {{ previewContent.age }}
                    </div>
                    <div class="app-comp__ad-status">
                      {{ previewContent.ad }}
                    </div>
                  </div>
                </div>
                <div class="app-comp__right-wrapper">
                  <div class="app-comp__choise">
                    <img src="/assets/lib-assets/classic-template/images/choise.png" />
                    <span> {{ staticTexts.infoChoice }} </span>
                  </div>
                  <div class="app-comp__users-rate">
                    @for (star of starsAmountRate; track star) {
                      <div class="star">
                        <span>
                          <img src="/assets/lib-assets/classic-template/images/star-full.webp" />
                        </span>
                      </div>
                    }
                    <div class="app-comp__user-num">
                      {{ previewContent.feedbacksAmount }}
                    </div>
                    <img alt="" src="/assets/lib-assets/classic-template/images/user.webp" />
                  </div>
                </div>
              </div>
              <div class="app-comp__install-wrapper__desktop">
                <div class="app-comp__wish-list-add">
                  <div class="app-comp__wish-list-img"></div>
                  <button class="app-comp__wish-list-button">
                    <span>{{ staticTexts.infoWishList }}</span>
                  </button>
                </div>
                <button
                  (click)="open.emit(true)"
                  *ngIf="isAppInstalled(); else installBtn"
                  class="app-comp__install-button active greenBtn openBtn"
                >
                  {{ staticTexts.infoOpen }}
                </button>
                <ng-template #installBtn>
                  <button
                    (click)="install.emit(true)"
                    class="app-comp__install-button active greenBtn"
                    id="install-button"
                    type="button"
                  >
                    {{ installResult() === 'started' ? staticTexts.infoLoading : staticTexts.infoInstall }}
                  </button>
                </ng-template>
              </div>
            </div>
          </div>
          <div class="app-comp__mobile-info">
            <div class="app-comp__mobile-info-item">
              <span class="app-comp__mobile-info-rating">
                <span>
                  {{ previewContent.rating }}
                </span>
                <svg
                  enable-background="new 0 0 24 24"
                  version="1.1"
                  viewBox="0 0 24 24"
                  xml:space="preserve"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g fill="none">
                    <path d="M0,0h24v24H0V0z"></path>
                    <path d="M0,0h24v24H0V0z"></path>
                  </g>
                  <path
                    d="M12,17.27L18.18,21l-1.64-7.03L22,9.24l-7.19-0.61L12,2L9.19,8.63L2,9.24l5.46,4.73L5.82,21L12,17.27z"
                  ></path>
                </svg>
              </span>
              <span class="app-comp__mobile-info-subtitle">
                {{ previewContent.feedbacksAmount }} {{ staticTexts.infoReviews }}
              </span>
            </div>
            <div class="app-comp__mobile-info-item">
              <span class="app-comp__mobile-info-icon">
                <svg viewBox="0 0 18 18" width="20" xmlns="http://www.w3.org/2000/svg">
                  <g transform="translate(21.552 22.5) rotate(180)">
                    <path
                      d="M.625,0h8.75A.68.68,0,0,1,10,.723a.68.68,0,0,1-.625.723H.625A.68.68,0,0,1,0,.723.68.68,0,0,1,.625,0Z"
                      data-name="Path 288"
                      transform="translate(7.552 7.652)"
                    ></path>
                    <g transform="translate(17.552 20.797) rotate(180)">
                      <path d="M0,0H9.666V9.666H0Z" data-name="Path 289" fill="none"></path>
                      <path
                        d="M8.752,4.642V11.81L5.536,8.678a.677.677,0,0,0-.936,0,.627.627,0,0,0,0,.9l4.343,4.229a.669.669,0,0,0,.929,0l4.343-4.229a.627.627,0,0,0,0-.9.669.669,0,0,0-.929,0L10.07,11.81V4.642a.659.659,0,0,0-1.318,0Z"
                        data-name="Path 290"
                        transform="translate(-4.408 -3.203)"
                      ></path>
                    </g>
                    <rect
                      data-name="Rectangle 123"
                      fill="none"
                      height="16"
                      rx="2"
                      stroke="#000"
                      stroke-width="2"
                      transform="translate(4.552 5.5)"
                      width="16"
                    ></rect>
                  </g>
                </svg>
              </span>
              <span class="app-comp__mobile-info-subtitle">
                {{ previewContent.size }}
              </span>
            </div>
            <div class="app-comp__mobile-info-item">
              <span class="app-comp__mobile-info-icon">
                <div class="app-comp__mobile-info-rate">
                  {{ previewContent.age }}
                </div>
              </span>
              <span class="app-comp__mobile-info-subtitle">
                {{ staticTexts.infoAge }}
              </span>
            </div>
          </div>
          <div class="app-comp__install-wrapper__mobile">
            <button
              (click)="open.emit(true)"
              *ngIf="isAppInstalled(); else installBtn"
              class="app-comp__install-button active greenBtn openBtn"
            >
              {{ staticTexts.infoOpen }}
            </button>
            <ng-template #installBtn>
              <button (click)="install.emit(true)" class="app-comp__install-button active greenBtn" type="button">
                {{ installResult() === 'started' ? staticTexts.infoLoading : staticTexts.infoInstall }}
              </button>
            </ng-template>
          </div>
          <div class="gallery">
            @if (config().headerVideoUrl) {
              @if (config().headerVideoUrl.includes('youtube') || config().headerVideoUrl.includes('youtu.be')) {
                <div class="gall_img">
                  <app-youtube-player [videoId]="previewYoutubeVideoId"></app-youtube-player>
                </div>
              } @else if (config().headerVideoUrl.includes('vimeo')) {
                <div class="gall_img">
                  <app-vimeo-player [videoUrl]="config().headerVideoUrl"></app-vimeo-player>
                </div>
              } @else if (config().headerVideoUrl) {
                <div class="gall_img">
                  <app-player [videoUrl]="config().headerVideoUrl"></app-player>
                </div>
              }
            }

            @for (bannerUrl of banners; track bannerUrl) {
              <div class="gall_img">
                <img alt="" [src]="bannerUrl" />
              </div>
            }
          </div>
          <div class="app-description">
            <div class="app-description__title">
              {{ staticTexts.descriptionTitle }}
            </div>
            <div class="app-description__content">
              <div [ngClass]="{ collapsed: !isDescriptionExpanded }" class="app-description__expand expand size">
                <p class="app-description__main-content" [innerHTML]="previewContent.description">
                </p>
              </div>
              <div class="shadow"></div>
            </div>
            <button
              class="expand-btn app-comp__install-button active greenBtn colapsed"
              type="button"
              (click)="toggleExpandBlock()"
            >
              @if (isDescriptionExpanded) {
                {{ staticTexts.descriptionLess }}
              } @else {
                {{ staticTexts.descriptionMore }}
              }
            </button>
          </div>
          <div class="line"></div>
          <div class="app-comp__charts">
            <h3 class="app-comp__section-header">
              {{ staticTexts.chartsTitle }}
            </h3>
            <div class="app-comp__charts-wrapper">
              <div class="score">
                <div class="score__number">
                  {{ previewContent.rating | number: '1.1' }}
                </div>
                <div class="score__stars">
                  @for (star of starsAmountRate; track star) {
                    <div class="star">
                      <span>
                        <img src="assets/lib-assets/classic-template/images/star-full-big.webp" />
                      </span>
                    </div>
                  }
                </div>
                <div class="score__all-users">
                  {{ staticTexts.chartsTotal }}
                  <img src="assets/lib-assets/classic-template/images/user.webp" />
                </div>
                <div class="score__ratings">
                  {{ previewContent.feedbacksAmount | shortNumber }}
                </div>
              </div>
              <div class="chart">
                <ol class="chart__bars">
                  @for (bar of starsChartBar; track bar.rate) {
                    <li class="chart__bar-container">
                      <span>{{ bar.rate }}</span>
                      <div class="chart__bar" [ngStyle]="{ width: bar.percentage + '%' }"></div>
                      <div class="chart__bg"></div>
                    </li>
                  }
                </ol>
              </div>
            </div>
          </div>

          @for (comment of sortedComments; track comment.author) {
            <div class="testimotials">
              <div class="testimotials__comment-info">
                <div class="testimotials__user-logo">
                  <img alt="Avatar" class="v-lazy-image"
                       [src]="(comment.avatar && comment.avatar.image) ? comment.avatar.image : 'assets/lib-assets/classic-template/images/logo_avatar_anonymous_color.png'" />
                </div>
                <div class="testimotials__user-info-wrapper">
                  <div class="testimotials__user-info-top">
                    <div class="testimotials__user-info-left">
                      <div class="testimotials__user-name">
                        {{ comment.author }}
                      </div>
                      <div class="testimotials__rate-info">
                        <div class="testimotials__rate-stars">
                          @for (star of getArray(comment.rating); track star) {
                            <div class="star">
                              <!--                          <span>-->
                              <!--                            <img src="assets/lib-assets/classic-template/images/star-full.webp" />-->
                              <!--                          </span>-->
                            </div>
                          }
                        </div>
                        <div class="testimotials__date">
                          {{ comment.date | objectToDate: 'commentDate' : contentLanguageCode() }}
                        </div>
                      </div>
                    </div>
                    <div class="tooltip">
                      <div class="testimotials__likes">
                        <i class="material-icons">thumb_up</i>
                        <span class="likes">
                          {{ comment.likes | shortNumber }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="testimotials__text-ph">
                    <div class="testimotials__text-visible">
                      {{ comment.commentContent }}
                    </div>

                    @if (comment.answerAuthor) {
                      <div class="testimotials__text-answer">
                        <div class="triangle"></div>
                        <div class="information__developer">
                          <div class="name__developer">
                            {{ comment.answerAuthor }}
                          </div>
                          <div class="sayphier__date">
                            {{ comment.answerDate | objectToDate: 'replyDate' : contentLanguageCode() : comment.date }}
                          </div>
                        </div>
                        <p class="text__answer">
                          {{ comment.answerContent }}
                        </p>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }

          <div class="line"></div>
          <div class="app-comp__recent-changes app-comp__main-recent-changes">
            <h3 class="app-comp__section-header app-comp__section-header_changes">
              {{ staticTexts.changesTitle }}
            </h3>
            <div class="app-comp__recent-changes-wrapper" [innerHTML]="previewContent.update">
            </div>
          </div>

          <div class="line"></div>

          <div class="app-comp__information">
            <span class="app-comp__section-header">{{ staticTexts.additionalTitle }}</span>
            <div class="info-items">
              <div class="info-items__item">
                <div class="info-items__title">
                  {{ staticTexts.additionalUpdatedTitle }}
                </div>
                <span>{{ previewContent.updateDate | objectToDate: 'updateDate' : contentLanguageCode() }}</span>
              </div>
              <div class="info-items__item">
                <div class="info-items__title">
                  {{ staticTexts.additionalSizeTitle }}
                </div>
                <span>{{ previewContent.size }}</span>
              </div>
              <div class="info-items__item">
                <div class="info-items__title">
                  {{ staticTexts.additionalInstallTitle }}
                </div>
                <span>{{ previewContent.uploadsAmount }}</span>
              </div>
              <div class="info-items__item">
                <div class="info-items__title">
                  {{ staticTexts.additionalVersionTitle }}
                </div>
                <span>{{ previewContent.version }}</span>
              </div>
              <div class="info-items__item">
                <div class="info-items__title">
                  {{ staticTexts.additionalAgeTitle }}
                </div>
                <span>{{ previewContent.age }}</span>
              </div>
              <div class="info-items__item">
                <div class="info-items__title">
                  {{ staticTexts.additionalDeveloperTitle }}
                </div>
                <span>{{ previewContent.developer }}</span>
              </div>
            </div>
          </div>
          <div class="line"></div>
        </div>
      </div>
    </section>
  </main>
</div>
